import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/* eslint-disable @typescript-eslint/no-explicit-any */
// Link de menu ativo: mesmo pathname e mesmo ?produto= (Biblioteca e Kids dividem /biblioteca)
export function isMenuLinkActive(path: string) {
  const link = new URL(path, window.location.origin);
  const current = new URLSearchParams(window.location.search);
  return link.pathname === window.location.pathname && link.searchParams.get('produto') === current.get('produto');
}

export function numberToBRL(value: number) {
  return Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
}
export function hexToRgb(hex: string): [number, number, number] {
  hex = hex.replace(/^#/, '');
  const bigint = parseInt(hex, 16);
  return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
}

export function formatDataList(promotions: any[], isMobile: boolean, onlyBigger: boolean) {
  const formattedPromotions: any = [];

  const physicalPromotions = promotions.filter((promo) => promo.mode === 'local');
  const onlinePromotions = promotions.filter((promo) => promo.mode === 'online');

  const addLargePhysicalPromotion = () => {
    if (!isMobile && physicalPromotions.length > 2) {
      formattedPromotions.push({
        type: 'large',
        promos: [physicalPromotions.shift(), physicalPromotions.shift(), physicalPromotions.shift()],
      });
    } else if (!isMobile && physicalPromotions.length > 1) {
      formattedPromotions.push({ type: 'large', promos: [physicalPromotions.shift(), physicalPromotions.shift()] });
    } else if (physicalPromotions.length > 0) {
      formattedPromotions.push({ type: 'large', promos: [physicalPromotions.shift()] });
    }
  };

  const addPairPromotions = (promos: any) => {
    if (!isMobile && promos.length > 3) {
      formattedPromotions.push({
        type: 'pair',
        promos: [promos.shift(), promos.shift(), promos.shift(),  promos.shift()],
      });
    } else if (promos.length >= 2) {
      const promo1 = promos.shift();
      const promo2 = promos.shift();

      if (promo1?.category === 'Cinema' || promo2.category === 'Cinema') {
        formattedPromotions.push({ type: 'large', promos: [promo1] });
        formattedPromotions.push({ type: 'large', promos: [promo2] });
      } else {
        formattedPromotions.push({
          type: 'pair',
          promos: [promo1, promo2],
        });
      }
    } else if (promos.length === 1) {
      formattedPromotions.push({
        type: 'pair',
        promos: [promos.shift()],
      });
    }
  };

  if (onlyBigger) {
    while (physicalPromotions.length > 0) {
      addLargePhysicalPromotion();
    }
  }

  while (physicalPromotions.length > 0 || onlinePromotions.length > 0) {
    addLargePhysicalPromotion();
    addPairPromotions(onlinePromotions);
    addLargePhysicalPromotion();
  }

  return formattedPromotions;
}

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}


export function setBrowserThemeColor(color: string) {
  try {
    // @ts-ignore
    document.querySelector('meta[name="theme-color"]').content = color;
  } catch {}
}